import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import uniqueId from 'lodash/uniqueId';
import classNames from 'classnames';

import { Circle } from './Circle.component';

const Step = ({ content, circleSize, circleAndTextSpace, lineTopPadding, firstStep, lastStep }) => (
	<div className="step">
		<div className="step-container">
			<div
				className="track"
				style={{
					width: circleSize,
					marginRight: circleAndTextSpace,
					paddingTop: lineTopPadding,
				}}
			>
				<div className="checkmark-icon">&#10003;</div>

				<Circle size={circleSize} showCheck={lastStep === true} />

				{/* Do not render the vertical line for the first step */}
				{firstStep !== true && (
					<div
						className="circle-connector"
						style={{
							marginTop: circleSize / 2,
						}}
					/>
				)}
			</div>
			<div
				className="step-body"
				// eslint-disable-next-line
				dangerouslySetInnerHTML={{
					__html: isString(content) ? content : '',
				}}
			/>
		</div>
	</div>
);

const Steppers = ({ className, circleSize, circleAndTextSpace, lineTopPadding, steps }) => {
	const keyPrefix = uniqueId();
	const cls = classNames('common-ui-steppers', {
		className,
	});

	return (
		<div className={cls}>
			{steps.map((step, idx) => (
				<Step
					circleSize={circleSize}
					circleAndTextSpace={circleAndTextSpace}
					lineTopPadding={lineTopPadding}
					content={step.message}
					firstStep={step.firstStep === true}
					lastStep={step.lastStep === true}
					key={`${keyPrefix}_${idx}`}
				/>
			))}
		</div>
	);
};

Steppers.defaultProps = {
	circleSize: 16,
	circleAndTextSpace: 20,
	lineTopPadding: 12,
};

Steppers.propTypes = {
	// Circle size
	circleSize: PropTypes.number,

	// Space between circle and body text
	circleAndTextSpace: PropTypes.number,

	lineTopPadding: PropTypes.number,

	// Array of steps
	steps: PropTypes.arrayOf(
		PropTypes.shape({
			// the first step
			firstStep: PropTypes.bool,

			// the last step
			lastStep: PropTypes.bool,

			// the body text
			message: PropTypes.string,
		})
	).isRequired,
};

export default Steppers;
